import React, { useContext } from 'react';
import MUITableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableContext from '../context/TableContext';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const NoDataWrapper = styled.div`
  padding: 30px;
  text-align: center;
  font-size: 1.3em;
  color: #aaa;
`;

const StyledRow = styled(TableRow)`
  &:nth-child(odd) {
    background-color: #efefef;
  }
`;

const TableBody = ({ onRowClick = () => {} }) => {
  const { columns, data, loading } = useContext(TableContext);

  return (
    <MUITableBody>
      {loading && <StyledRow></StyledRow>}
      {data?.map((row, rowIndex) => {
        return (
          <StyledRow key={rowIndex} onClick={() => onRowClick(row)} hover>
            {columns?.map((column, index) => {
              return (
                <TableCell key={index} align={column.align || 'left'}>
                  {row?.[column.id]}
                </TableCell>
              );
            })}
          </StyledRow>
        );
      })}
      {data?.length === 0 && (<TableRow>
        <TableCell colSpan={columns.length}>
          <NoDataWrapper>
            --- <FormattedMessage id={'base.noData'} /> ---
          </NoDataWrapper>
        </TableCell>
      </TableRow>)}
    </MUITableBody>
  );
};

export default TableBody;
